import { GET_REPORT_DATA } from './mutation-types'
import relatorioSinteticoHttpService from '../_services/relatorioSinteticoHttpService'

export default {
  obterDadosRelatorio: async ({ commit }, form) => {
    try {
      const [
        responseTotais,
        responseDiasCorridos,
        responseHora,
        responseMediaDias,
        responseMediaHora,
      ] = await Promise.all([
        relatorioSinteticoHttpService.getValoresTotaisResumidoFila(form),
        relatorioSinteticoHttpService.getValoresDiasCorridosResumidoFila(form),
        relatorioSinteticoHttpService.getValoresHoraResumidoFila(form),
        relatorioSinteticoHttpService.getValoresMediaDiasResumidoFila(form),
        relatorioSinteticoHttpService.getValoresMediaHoraResumidoFila(form),
      ])

      const responseData = Object.assign(
        responseTotais.data,
        responseDiasCorridos.data,
        responseHora.data,
        responseMediaDias.data,
        responseMediaHora.data
      )

      commit(GET_REPORT_DATA, responseData)
    } catch (e) {
      console.log(e)
      throw e
    }
  },
}
